import { Calendar, Clock, Database, Download, Eye } from "lucide-react";
import { BarChart } from "recharts";
import { Button } from "../../../../../shared/components/button/Button";
import { Link } from "react-router-dom";
import {
  resolveDataLibraryDocs,
  resolveDataLibraryLens,
} from "../../../../../shared/lib/routesResolver";

const DataLibraryCard = ({ dataLibrary }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="p-6 border-b bg-muted/20">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-bold">{dataLibrary?.name}</h3>
          <span className="text-xs font-medium bg-muted px-2 py-1 rounded-full">
            {dataLibrary?.metrics} metrics
          </span>
        </div>
        <p className="text-muted-foreground">{dataLibrary?.description}</p>
      </div>
      <div className="p-4 space-y-4">
        <div className="flex items-center text-sm">
          <Calendar className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-muted-foreground">From Jan 2023</span>
          <span className="mx-2 text-muted-foreground">|</span>
          <Clock className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-muted-foreground">Weekly updates</span>
        </div>
        <div className="flex items-center text-sm">
          <Database className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-muted-foreground">
            {dataLibrary?.records} records
          </span>
          <span className="mx-2 text-muted-foreground">|</span>
          <BarChart className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-muted-foreground">
            {dataLibrary?.dimensions} dimensions
          </span>
        </div>
        <div className="flex justify-between pt-2">
          <Button variant="outline" size="sm" className="w-[48%]" asChild>
            <Link
              to={resolveDataLibraryDocs(dataLibrary?.code)}
              state={{ id: dataLibrary?.code }}
            >
              <Eye className="h-4 w-4 mr-2" />
              View Details
            </Link>
          </Button>
          <Button
            size="sm"
            className="w-[48%] bg-primary text-white hover:bg-primary/90"
            asChild
          >
            <Link
              to={resolveDataLibraryLens(dataLibrary?.code)}
              state={{ id: dataLibrary?.code }}
            >
              <Download className="h-4 w-4 mr-2" />
              Prepare Data
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DataLibraryCard;
